import React from 'react';
import Img from './Img';
import {CardStyles} from '../styles/Card';



const Card = ({imgUrl, children, ...props}) => {
  return (
    <CardStyles {...props} className="card">
      {
        imgUrl && <Img src={imgUrl} wrapProps={{className: 'img'}}/>
      }
      <div className="card-body">
        {children}
      </div>
    </CardStyles>
  )
}

export default Card;
